<div [formGroup]="formGroup" class="flex flex-col w-full" *transloco="let t">
  <mat-form-field appearance="outline" class="fuse-mat-dense flex-auto" [subscriptSizing]="subscriptSizing">
    @if (label) {
      <mat-label>{{ t(label) | capitalize }}</mat-label>
    }

    <input
      matInput
      [matDatepicker]="datePicker"
      [min]="min"
      [max]="max"
      [name]="controlName"
      [placeholder]="placeholder"
      [formControlName]="controlName"
      [autocomplete]="autocomplete"
      [readonly]="disableManualInput"
      (focus)="disableManualInput ? datePicker.open() : ''"
      (click)="disableManualInput ? datePicker.open() : ''"
      [maxLength]="maxLength"
      (keypress)="onKeyDown($event)"
    />

    <mat-datepicker-toggle matSuffix [for]="datePicker" tabindex="-1"></mat-datepicker-toggle>

    <mat-datepicker
      [disabled]="formControl.disabled"
      [startView]="startView"
      (monthSelected)="setMonthAndYear($event, datePicker)"
      #datePicker
      [touchUi]="touchUi"
    ></mat-datepicker>

    @if (formControl?.errors ?? {} | firstErrorMessage: formControl : errorMessages; as errorMessage) {
      <mat-error>{{ t(errorMessage) | capitalize }}</mat-error>
    }
  </mat-form-field>
</div>
